import React from 'react'
import {MembersPageRuntimeContext} from '../components/runtime-context/context'
import {MembersPageState} from '../types/state'

export const useMembersPageSelector = <T>(selector: (state: MembersPageState) => T): T =>
  selector(React.useContext(MembersPageRuntimeContext).state)

export const useMembersPageActions = () => React.useContext(MembersPageRuntimeContext).actions

export const useMembersPageRuntimeContext = () => React.useContext(MembersPageRuntimeContext)
